/** QR.module.css / 인쇄 템플릿과 동일한 스티커 레이아웃 (논리 폭 200px) */

import storeQrFrameBox from '../images/storeQrFrameBox.png';

/** giftManage.js 상품 QR 카드형 레이아웃 전용 치수 */
const CARD_W = 200;
const PAD_X = 14;
const PAD_TOP = 18;
const PAD_BOTTOM = 14;
const RADIUS_CARD = 10;
/** 그림자·블러가 잘리지 않도록 캔버스 여백 */
const CANVAS_PAD = 26;
const GAP = 10;
const TITLE_FS = 16;
const TITLE_LH = 20;
const SCAN_FS = 13;
const SCAN_LH = 17;
/** 기본 QR 크기(카드형 레이아웃) */
const QR_SIZE_DEFAULT = 120;
const FOOTER_FS = 12;
const FOOTER_LH = Math.round(FOOTER_FS * 1.4);
const FOOTER_PAD_X = 8;
const FOOTER_PAD_Y = 6;
const FOOTER_RADIUS = 6;
const FOOTER_TEXT = '#000000';
const FOOTER_TOP_MARGIN = 4;
/** 헤더 문구 아래 여백(타이틀·스캔 안내 블록 높이) */
const HEAD_BOTTOM_PAD = 12;

let crcTable;
function crc32(bytes) {
  if (!crcTable) {
    crcTable = new Uint32Array(256);
    for (let n = 0; n < 256; n += 1) {
      let c = n;
      for (let k = 0; k < 8; k += 1) {
        c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
      }
      crcTable[n] = c;
    }
  }
  let crc = 0xffffffff;
  for (let i = 0; i < bytes.length; i += 1) {
    crc = crcTable[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
}

/**
 * PNG의 IHDR 청크 바로 뒤에 pHYs 청크를 삽입해 물리적 해상도(DPI)를 기록한다.
 * Preview/사진앱 등 DPI 메타데이터를 존중하는 프로그램에서 "실제 크기"로 인쇄하면
 * 이 DPI 기준의 물리 크기로 출력된다 — 브라우저 자체 인쇄(CSS cm)와는 별개의 경로.
 * @param {ArrayBuffer} pngBuffer
 * @param {number} dpi
 * @returns {ArrayBuffer}
 */
function embedPngDpi(pngBuffer, dpi) {
  const pixelsPerMeter = Math.round(dpi / 0.0254);
  const bytes = new Uint8Array(pngBuffer);

  // PNG 시그니처(8바이트) 다음, IHDR 청크(길이4+타입4+데이터13+CRC4=25바이트) 바로 뒤가 삽입 지점
  const insertAt = 8 + 25;

  const physData = new Uint8Array(9);
  const dv = new DataView(physData.buffer);
  dv.setUint32(0, pixelsPerMeter); // pixels per unit, X axis
  dv.setUint32(4, pixelsPerMeter); // pixels per unit, Y axis
  physData[8] = 1; // unit specifier: 1 = meter

  const typeAndData = new Uint8Array(4 + physData.length);
  typeAndData.set([0x70, 0x48, 0x59, 0x73], 0); // 'pHYs'
  typeAndData.set(physData, 4);

  const chunk = new Uint8Array(4 + typeAndData.length + 4);
  new DataView(chunk.buffer).setUint32(0, physData.length);
  chunk.set(typeAndData, 4);
  new DataView(chunk.buffer).setUint32(4 + typeAndData.length, crc32(typeAndData));

  const out = new Uint8Array(bytes.length + chunk.length);
  out.set(bytes.subarray(0, insertAt), 0);
  out.set(chunk, insertAt);
  out.set(bytes.subarray(insertAt), insertAt + chunk.length);
  return out.buffer;
}

/**
 * JPEG(JFIF) 헤더의 density 필드를 patch해서 물리적 해상도(DPI)를 기록한다.
 * 크롬이 만드는 JPEG는 SOI 다음 APP0(JFIF) 세그먼트에 density 필드가 이미 자리 잡고 있으므로
 * (기본값 units=0, 1x1 "비율만") 그 값만 덮어쓰면 되고, PNG처럼 청크를 새로 끼워넣을 필요는 없다.
 * @param {ArrayBuffer} jpegBuffer
 * @param {number} dpi
 * @returns {ArrayBuffer}
 */
function embedJpegDpi(jpegBuffer, dpi) {
  const bytes = new Uint8Array(jpegBuffer);
  if (bytes[0] !== 0xff || bytes[1] !== 0xd8) return jpegBuffer; // SOI 없음 — JPEG 아님

  let offset = 2;
  while (offset + 4 <= bytes.length && bytes[offset] === 0xff) {
    const marker = bytes[offset + 1];
    const segLen = (bytes[offset + 2] << 8) | bytes[offset + 3];
    const isApp0Jfif =
      marker === 0xe0 &&
      bytes[offset + 4] === 0x4a && // 'J'
      bytes[offset + 5] === 0x46 && // 'F'
      bytes[offset + 6] === 0x49 && // 'I'
      bytes[offset + 7] === 0x46 && // 'F'
      bytes[offset + 8] === 0x00;
    if (isApp0Jfif) {
      const out = new Uint8Array(bytes); // copy — 원본 buffer 보존
      const dv = new DataView(out.buffer);
      const unitsOffset = offset + 2 + 2 + 5 + 2; // len(2)+identifier(5)+version(2) 뒤가 units
      out[unitsOffset] = 1; // 1 = dots per inch
      dv.setUint16(unitsOffset + 1, Math.round(dpi)); // Xdensity
      dv.setUint16(unitsOffset + 3, Math.round(dpi)); // Ydensity
      return out.buffer;
    }
    if (marker === 0xd8 || marker === 0xd9 || (marker >= 0xd0 && marker <= 0xd7)) {
      offset += 2;
    } else {
      offset += 2 + segLen;
    }
    if (marker === 0xda) break; // Start of Scan — 이 뒤엔 헤더 세그먼트 없음
  }
  return jpegBuffer; // JFIF APP0을 못 찾음 — 메타데이터 없이 그대로 반환
}

function arrayBufferToDataUrl(buffer, mimeType) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode.apply(
      null,
      bytes.subarray(i, i + chunkSize),
    );
  }
  return `data:${mimeType};base64,${btoa(binary)}`;
}

function roundRectPath(ctx, x, y, w, h, r) {
  const rr = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.lineTo(x + w - rr, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + rr);
  ctx.lineTo(x + w, y + h - rr);
  ctx.quadraticCurveTo(x + w, y + h, x + w - rr, y + h);
  ctx.lineTo(x + rr, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - rr);
  ctx.lineTo(x, y + rr);
  ctx.quadraticCurveTo(x, y, x + rr, y);
  ctx.closePath();
}

function wrapLines(ctx, text, maxW) {
  const lines = [];
  let line = '';
  const s = String(text || '');
  for (let i = 0; i < s.length; i += 1) {
    const ch = s[i];
    const test = line + ch;
    if (ctx.measureText(test).width > maxW && line.length > 0) {
      lines.push(line);
      line = ch;
    } else {
      line = test;
    }
  }
  if (line.length > 0) lines.push(line);
  return lines.length ? lines : [''];
}

/**
 * storeManage.js 선물하기 QR — 채널 "전체상점QR" 7cm x 10cm 카드
 * (storeEntryQrPrint.js openStoreEntryQrBulkPrint) 와 동일한 문구 구성.
 * footerSteps 는 카드 하단 보라 배너의 4단계 알약 리스트에 그대로 매핑된다.
 */
export function getGiftQrStickerStrings(language, storeNameRaw) {
  const storeName =
    language === 'en'
      ? storeNameRaw || 'My café'
      : storeNameRaw || '내카페';
  const giftLabel = language === 'en' ? 'Gift' : '선물하기';
  const scanText =
    language === 'en'
      ? 'Scan with the "Naegift" app'
      : '"내기프트 앱"으로 QR 스캔하세요';
  const footerTitle =
    language === 'en' ? 'How to use a received gift' : '받은 선물 사용하기';
  const footerSteps =
    language === 'en'
      ? [
          'Scan QR with the "Naegift" app',
          'Pick a gift from your gift box',
          'Self-verify',
          'Present the result screen',
        ]
      : [
          '"내기프트 앱"으로 QR 스캔',
          '받은선물함에서 선물 선택',
          '셀프 검증',
          '결과 화면 제시',
        ];
  return { storeName, giftLabel, scanText, footerTitle, footerSteps };
}

/** 기프트 상세(shopuser `/gift/:storeNo/:giftNo`) QR 스티커용 문구 */
export function getGiftProductQrStickerStrings(language, giftNameRaw) {
  const productName =
    language === 'en' ? giftNameRaw || 'Gift' : giftNameRaw || '기프트';
  const giftLabel = language === 'en' ? 'Product page' : '기프트 상세';
  const scanText =
    language === 'en'
      ? 'Scan with your smartphone camera'
      : '스마트폰 카메라로 스캔하세요';
  const footerParagraphs =
    language === 'en'
      ? [
          'Visit Naegift (www.naegift.com) to discover a variety of gifts~',
          'Powered by Authrium Co., Ltd.',
        ]
      : [
          '내기프트(www.naegift.com)로 들어오시면 다양한 기프트를 만날 수 있어요~',
          'Powered by (주)오스리움',
        ];
  return { storeName: productName, giftLabel, scanText, footerParagraphs };
}

/** pHYs 청크에 기록할 DPI. 채널 "개별인쇄" 이미지저장(storeEntryQrPrint.js buildStickerDataUrl,
 *  SCALE = 300/96)과 동일하게 300dpi(인쇄 표준 해상도)로 맞춘다 — 96dpi로는 실제 인쇄 시 흐릿하다 */
const PHYSICAL_DPI = 300;

/** JPEG로 내보낼 때 품질(0~1). QR의 딱딱한 모듈 경계에 JPEG 압축 링잉이 최대한 안 보이도록 높게 잡는다 */
const JPEG_QUALITY = 0.95;

/**
 * @param {HTMLCanvasElement} qrCanvas
 * @param {{
 *   storeName: string, giftLabel: string,
 *   scanText: string | string[], footerParagraphs: string[],
 *   scale?: number, cardWidth?: number, qrSize?: number,
 *   imageFormat?: 'png' | 'jpeg',
 * }} opts 카드형(그림자·테두리 + QR 그라데이션 박스) 레이아웃. giftManage.js 상품 QR 전용.
 *   imageFormat 기본값은 'png'(무손실). 'jpeg'는 QR의 딱딱한 경계에 압축 손실이 생길 수 있어
 *   품질을 높게(0.95) 고정해 사용한다.
 * @returns {Promise<string>} data URL (imageFormat에 맞는 MIME)
 */
export async function giftQrStickerToDataURL(qrCanvas, opts) {
  const {
    storeName,
    giftLabel,
    scanText,
    footerParagraphs,
    scale: scaleIn = 2,
    imageFormat = 'png',
    cardWidth = CARD_W,
    qrSize = QR_SIZE_DEFAULT,
  } = opts;
  const scale = Math.max(1, Math.min(4, scaleIn));

  const cardW = cardWidth;
  const innerW = cardW - PAD_X * 2;
  const qrBoxH = 10 + qrSize + 10;
  const fontStack = '-apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", sans-serif';
  const titleFont = `600 ${TITLE_FS}px ${fontStack}`;
  const scanFont = `500 ${SCAN_FS}px ${fontStack}`;

  const measure = document.createElement('canvas').getContext('2d');

  measure.font = titleFont;
  const titleLines = wrapLines(measure, `${storeName} ${giftLabel}`, innerW);

  measure.font = scanFont;
  const scanParagraphs = Array.isArray(scanText) ? scanText : [scanText];
  const scanLines = [];
  scanParagraphs.forEach(para => {
    wrapLines(measure, para, innerW).forEach(l => scanLines.push(l));
  });

  const footerInnerW = innerW - FOOTER_PAD_X * 2;
  measure.font = `400 ${FOOTER_FS}px ${fontStack}`;
  const footerTextLines = [];
  footerParagraphs.forEach(para => {
    wrapLines(measure, para, footerInnerW).forEach(l =>
      footerTextLines.push(l),
    );
  });
  const footerContentH = footerTextLines.length * FOOTER_LH;
  const footerH = FOOTER_PAD_Y * 2 + footerContentH;

  const titleBlockH = titleLines.length * TITLE_LH;
  const scanBlockH = scanLines.length * SCAN_LH;

  const headH = PAD_TOP + titleBlockH + scanBlockH + HEAD_BOTTOM_PAD;
  const bodyY = headH + GAP;
  const footerY = bodyY + qrBoxH + GAP + FOOTER_TOP_MARGIN;
  const contentH = footerY + footerH + PAD_BOTTOM;

  const canvasPad = CANVAS_PAD;

  const out = document.createElement('canvas');
  out.width = Math.round((cardW + canvasPad * 2) * scale);
  out.height = Math.round((contentH + canvasPad * 2) * scale);
  const ctx = out.getContext('2d');
  if (!ctx) return qrCanvas.toDataURL('image/png');

  ctx.scale(scale, scale);
  ctx.translate(canvasPad, canvasPad);

  if (imageFormat === 'jpeg') {
    // JPEG는 투명을 지원하지 않아 카드 모서리의 둥근 바깥쪽이 검게 나온다 — 미리 흰색으로 채운다
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(
      -canvasPad,
      -canvasPad,
      cardW + canvasPad * 2,
      contentH + canvasPad * 2,
    );
  }

  ctx.save();
  ctx.shadowColor = 'rgba(15, 23, 42, 0.2)';
  ctx.shadowBlur = 22;
  ctx.shadowOffsetY = 9;
  ctx.shadowOffsetX = 0;
  roundRectPath(ctx, 0, 0, cardW, contentH, RADIUS_CARD);
  ctx.fillStyle = '#ffffff';
  ctx.fill();
  ctx.restore();

  roundRectPath(ctx, 0, 0, cardW, contentH, RADIUS_CARD);
  ctx.fillStyle = '#ffffff';
  ctx.fill();
  ctx.strokeStyle = 'rgba(15, 23, 42, 0.09)';
  ctx.lineWidth = 1;
  ctx.stroke();

  let ty = PAD_TOP;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'top';
  ctx.fillStyle = '#000000';
  ctx.font = titleFont;
  titleLines.forEach(line => {
    ctx.fillText(line, cardW / 2, ty);
    ty += TITLE_LH;
  });

  ctx.font = scanFont;
  scanLines.forEach(line => {
    ctx.fillText(line, cardW / 2, ty);
    ty += SCAN_LH;
  });

  ctx.strokeStyle = 'rgba(15, 23, 42, 0.06)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(PAD_X, headH);
  ctx.lineTo(cardW - PAD_X, headH);
  ctx.stroke();

  const bodyX = PAD_X;
  roundRectPath(ctx, bodyX, bodyY, innerW, qrBoxH, RADIUS_CARD);
  const bodyGrad = ctx.createLinearGradient(0, bodyY, 0, bodyY + qrBoxH);
  bodyGrad.addColorStop(0, '#fafafa');
  bodyGrad.addColorStop(0.45, '#ffffff');
  ctx.fillStyle = bodyGrad;
  ctx.fill();
  ctx.strokeStyle = 'rgba(15, 23, 42, 0.08)';
  ctx.lineWidth = 1;
  ctx.stroke();

  const qrX = bodyX + (innerW - qrSize) / 2;
  const qrY = bodyY + 10;
  // 확대 scale로 그릴 때 블러 없이 또렷한 QR 모듈 경계를 유지
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
  ctx.imageSmoothingEnabled = true;

  roundRectPath(ctx, bodyX, footerY, innerW, footerH, FOOTER_RADIUS);
  ctx.fillStyle = '#f8fafc';
  ctx.fill();
  ctx.strokeStyle = 'rgba(15, 23, 42, 0.07)';
  ctx.lineWidth = 1;
  ctx.stroke();

  ctx.fillStyle = FOOTER_TEXT;
  let fy = footerY + FOOTER_PAD_Y;
  footerTextLines.forEach(line => {
    ctx.font = `400 ${FOOTER_FS}px ${fontStack}`;
    ctx.fillText(line, cardW / 2, fy);
    fy += FOOTER_LH;
  });

  const mimeType = imageFormat === 'jpeg' ? 'image/jpeg' : 'image/png';

  try {
    return out.toDataURL(mimeType, JPEG_QUALITY);
  } catch (err) {
    console.warn('giftQrStickerToDataURL failed:', err);
    try {
      return qrCanvas.toDataURL(mimeType, JPEG_QUALITY);
    } catch {
      return '';
    }
  }
}

/* ------------------------------------------------------------------------
 * 채널 "개별인쇄" 6.98cm x 6.98cm 정사각 카드(storeEntryQrPrint.js
 * openStoreEntryQrPrint > buildStickerDataUrl)와 동일한 노랑/보라 디자인.
 * storeManage.js 선물하기 QR 다운로드·인쇄 전용 — 전체상점QR(7x10cm, 세로 카드) 과는
 * 다른 디자인이니 혼동하지 말 것. 좌표는 96dpi 기준 그 카드의 값(264x264, qrWrap
 * 153x142, footer 85, 2열x2행 알약 그리드 등)을 그대로 캔버스에 옮긴 것.
 * ------------------------------------------------------------------------ */
const CH_CARD_W = 264;
const CH_CARD_H = 264;
const CH_HEAD_PAD_TOP = 16;
const CH_TITLE_FS = 16;
const CH_TITLE_LH = 18;
const CH_TITLE_MAX_LINES = 2;
const CH_TITLE_MAX_W = CH_CARD_W - 12;
const CH_HEAD_GAP = 2;
const CH_SCAN_FS = 14;
const CH_SCAN_LH = 17;
const CH_QR_BOX_W = 153;
const CH_QR_BOX_H = 142;
const CH_QR_SIZE = 71;
const CH_QR_OFFSET_X = 38;
const CH_QR_OFFSET_Y = 44;
const CH_FOOTER_H = 85;
const CH_FOOTER_PAD_X = 10;
const CH_FOOTER_PAD_TOP = 7;
const CH_FOOTER_TITLE_FS = 14;
const CH_PILL_FS = 9;
const CH_PILL_H = 21;
const CH_PILL_GAP = 4;
const CH_YELLOW = '#FFEC00';
const CH_PURPLE = '#881D99';
const CH_GOTHIC_STACK =
  '-apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif';

function loadImageAsync(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

/** CSS `-webkit-line-clamp: N` 과 동일하게 최대 N줄로 감싸고, 넘치면 마지막 줄을 말줄임한다 */
function wrapLinesClamped(ctx, text, maxW, maxLines) {
  const lines = wrapLines(ctx, text, maxW);
  if (lines.length <= maxLines) return lines;
  const clamped = lines.slice(0, maxLines);
  let last = clamped[maxLines - 1];
  while (last.length > 0 && ctx.measureText(`${last}…`).width > maxW) {
    last = last.slice(0, -1);
  }
  clamped[maxLines - 1] = `${last}…`;
  return clamped;
}

/**
 * @param {HTMLCanvasElement} qrCanvas 화면에 이미 렌더된 QRCodeCanvas
 * @param {{ storeName: string, giftLabel: string, scanText: string, footerTitle: string,
 *   footerSteps: string[], cardPhysicalWidthCm?: number, imageFormat?: 'png' | 'jpeg' }} opts
 * @returns {Promise<string>} data URL
 */
export async function buildChannelStoreQrStickerDataUrl(qrCanvas, opts) {
  const {
    storeName,
    giftLabel,
    scanText,
    footerTitle,
    footerSteps,
    // 개별인쇄(storeEntryQrPrint.js openStoreEntryQrPrint) 카드의 실제 물리 규격 6.98cm
    cardPhysicalWidthCm = 6.98,
    imageFormat = 'jpeg',
  } = opts;

  await Promise.all([
    document.fonts.load(`600 ${CH_TITLE_FS}px "YeogiOttaeJalnan"`),
    document.fonts.load(`400 ${CH_SCAN_FS}px "YeogiOttaeJalnanGothic"`),
    document.fonts.load(`600 ${CH_FOOTER_TITLE_FS}px "YeogiOttaeJalnanGothic"`),
    document.fonts.load(`400 ${CH_PILL_FS}px "YeogiOttaeJalnanGothic"`),
  ]).catch(() => {});
  const frameImg = await loadImageAsync(storeQrFrameBox);

  const scale = ((cardPhysicalWidthCm / 2.54) * PHYSICAL_DPI) / CH_CARD_W;

  const out = document.createElement('canvas');
  out.width = Math.round(CH_CARD_W * scale);
  out.height = Math.round(CH_CARD_H * scale);
  const ctx = out.getContext('2d');
  if (!ctx) return qrCanvas.toDataURL('image/png');
  ctx.scale(scale, scale);

  ctx.fillStyle = CH_YELLOW;
  ctx.fillRect(0, 0, CH_CARD_W, CH_CARD_H);

  ctx.textAlign = 'center';
  ctx.textBaseline = 'top';

  // 제목이 한 줄에 안 들어가면 최대 2줄까지 접되(개별인쇄 원본과 동일), 그만큼
  // 위 여백·QR박스 앞 간격을 줄여서 QR박스 시작 y가 한 줄일 때와 크게 벌어지지 않게 한다.
  ctx.font = `600 ${CH_TITLE_FS}px "YeogiOttaeJalnan", ${CH_GOTHIC_STACK}`;
  const titleLines = wrapLinesClamped(
    ctx,
    `${storeName} ${giftLabel}`.trim(),
    CH_TITLE_MAX_W,
    CH_TITLE_MAX_LINES,
  );
  ctx.fillStyle = CH_PURPLE;
  let ty;
  let qrGap;
  if (titleLines.length <= 1) {
    ty = CH_HEAD_PAD_TOP;
    ctx.fillText(titleLines[0], CH_CARD_W / 2, ty);
    ty += CH_TITLE_LH + CH_HEAD_GAP;
    qrGap = 6;
  } else {
    ty = 5;
    titleLines.forEach(line => {
      ctx.fillText(line, CH_CARD_W / 2, ty);
      ty += CH_TITLE_LH;
    });
    qrGap = 1;
  }

  ctx.font = `400 ${CH_SCAN_FS}px "YeogiOttaeJalnanGothic", ${CH_GOTHIC_STACK}`;
  ctx.fillStyle = '#000000';
  ctx.fillText(scanText, CH_CARD_W / 2, ty);
  ty += CH_SCAN_LH;

  const qrBoxX = (CH_CARD_W - CH_QR_BOX_W) / 2;
  const qrBoxY = ty + qrGap;
  ctx.drawImage(frameImg, qrBoxX, qrBoxY, CH_QR_BOX_W, CH_QR_BOX_H);
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(
    qrCanvas,
    qrBoxX + CH_QR_OFFSET_X,
    qrBoxY + CH_QR_OFFSET_Y,
    CH_QR_SIZE,
    CH_QR_SIZE,
  );
  ctx.imageSmoothingEnabled = true;

  const footerY = CH_CARD_H - CH_FOOTER_H;
  ctx.fillStyle = CH_PURPLE;
  ctx.fillRect(0, footerY, CH_CARD_W, CH_FOOTER_H);

  ctx.fillStyle = CH_YELLOW;
  ctx.font = `600 ${CH_FOOTER_TITLE_FS}px "YeogiOttaeJalnanGothic", ${CH_GOTHIC_STACK}`;
  ctx.fillText(footerTitle, CH_CARD_W / 2, footerY + CH_FOOTER_PAD_TOP);

  // 2열 x N행 흰색 알약 그리드 — 개별인쇄 원본은 정확히 4단계를 2x2로 고정 배치했지만
  // 여기선 footerSteps 길이에 맞춰 일반화한다(현재 호출부는 항상 4개라 결과는 동일).
  const innerW = CH_CARD_W - CH_FOOTER_PAD_X * 2;
  const colW = (innerW - CH_PILL_GAP) / 2;
  const listTop = footerY + CH_FOOTER_PAD_TOP + CH_FOOTER_TITLE_FS + 6;
  ctx.font = `400 ${CH_PILL_FS}px "YeogiOttaeJalnanGothic", ${CH_GOTHIC_STACK}`;
  (footerSteps || []).forEach((label, i) => {
    const col = i % 2;
    const row = Math.floor(i / 2);
    const x = CH_FOOTER_PAD_X + col * (colW + CH_PILL_GAP);
    const y = listTop + row * (CH_PILL_H + CH_PILL_GAP);

    roundRectPath(ctx, x, y, colW, CH_PILL_H, 6);
    ctx.fillStyle = '#ffffff';
    ctx.fill();

    ctx.fillStyle = CH_PURPLE;
    ctx.fillText(`${i + 1} ${label}`, x + colW / 2, y + (CH_PILL_H - CH_PILL_FS) / 2);
  });

  const mimeType = imageFormat === 'jpeg' ? 'image/jpeg' : 'image/png';
  try {
    const blob = await new Promise(resolve =>
      out.toBlob(resolve, mimeType, JPEG_QUALITY),
    );
    if (!blob) return out.toDataURL(mimeType, JPEG_QUALITY);
    const buffer = await blob.arrayBuffer();
    const withDpi =
      imageFormat === 'jpeg'
        ? embedJpegDpi(buffer, PHYSICAL_DPI)
        : embedPngDpi(buffer, PHYSICAL_DPI);
    return arrayBufferToDataUrl(withDpi, mimeType);
  } catch (err) {
    console.warn('buildChannelStoreQrStickerDataUrl failed:', err);
    try {
      return out.toDataURL(mimeType, JPEG_QUALITY);
    } catch {
      return '';
    }
  }
}
